import React from "react";
import WeekDayButton from "../Button/WeekDayButton";
import { transform_timezone } from "../Transformation/Transformations";

function formatTime12h(time) {
  const [hourStr, minute] = time.split(":");
  let hour = parseInt(hourStr, 10);
  const suffix = hour >= 12 ? "PM" : "AM";
  hour = hour % 12 || 12;
  return `${hour}:${minute} ${suffix}`;
}

function LeaderProfileAvailability({
  t,
  user_timezone,
  dayArray,
  allBookedSlots,
  selectedSlots,
  handleSlotToggle
}) {
  return (
    <>
      <div className="flex justify-center text-2xl md:text-3xl mt-16 font-bold">
        {t("leader_profile.availability_title")}
      </div>
      <span className="flex justify-center mt-2 font-medium text-lg">
        {t("meeting.table_text")}{" "}
        <span style={{ color: "red" }}>
          {" "}
          {t(transform_timezone(user_timezone))}{" "}
        </span>
      </span>
      <div className=" flex flex-col gap-8 md:gap-5 md:mt-8 justify-center">
        <div className="overflow-scroll md:overflow-auto">
          <div className="grid grid-cols-7 p-4 xl:px-[220px] lg:px-28 w-[800px] md:w-full">
            {dayArray.map((day) => (
              <div key={day} className="flex flex-col items-center">
                <WeekDayButton name={day} />
                <div className="space-y-2 mt-3">
                  {allBookedSlots[day]?.length > 0 ? (
                    allBookedSlots[day].map((time, index) => (
                      <div
                        key={index}
                        onClick={() => handleSlotToggle(day, time)}
                        className={`text-center px-4 py-2 border rounded font-semibold text-lg cursor-pointer ${
                          selectedSlots?.day === day &&
                          selectedSlots?.time === time
                            ? "bg-[var(--brand)] text-white"
                            : "bg-white text-gray-700 border-gray-300"
                        }`}
                      >
                        {formatTime12h(time)}
                      </div>
                    ))
                  ) : (
                    <div className="text-gray-700 text-md font-semibold">
                      No slots
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default LeaderProfileAvailability;
